
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-inline--fa fa-washer fa-w-14 fa-3x",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","data-icon":"washer","data-prefix":"fal","viewBox":"0 0 446 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M384-1H64C28.654-1 0 27.654 0 63v416c0 17.673 14.327 32 32 32h384c17.673 0 32-14.327 32-32V63c0-35.346-28.654-64-64-64zm32 480H32V63c0-17.673 14.327-32 32-32h320c17.673 0 32 14.327 32 32zM80 95c14.255 0 21.392-17.234 11.313-27.313C81.234 57.607 64 64.745 64 79c0 8.837 7.163 16 16 16zm64 0c14.255 0 21.392-17.234 11.313-27.313C145.234 57.607 128 64.745 128 79c0 8.837 7.163 16 16 16z"}}),_c('path',{attrs:{"d":"M182.64 422.787h-20.136v-58.993c34.467-7.998 59.425-40.225 56.078-77.602l-8.03-89.654c-.372-4.148-3.8-7.324-7.907-7.324H90.147c-4.102 0-7.536 3.176-7.903 7.324l-8.034 89.659c-3.348 37.377 21.61 69.604 56.077 77.602v58.988h-20.135c-11.12 0-20.136 9.015-20.136 20.135a4.026 4.026 0 004.027 4.027h104.705a4.026 4.026 0 004.027-4.027c0-11.12-9.015-20.135-20.135-20.135z"}}),_c('rect',{attrs:{"width":"32.203","height":"257.696","x":"262.205","y":"189.208","opacity":".98","ry":"16.449"}}),_c('rect',{attrs:{"width":"32.203","height":"257.696","x":"337.732","y":"189.208","opacity":".98","ry":"16.449"}})])
          )
        }
      }
    